
/// <reference path="../notes/NoteListViewController.ts" />
/// <reference path="../AppHelper.ts" />


class TransferNoteListViewController extends NoteListViewController
{
    static newInstance() : TransferNoteListViewController {
        let vc = new TransferNoteListViewController("transfer-note-list-view");
        vc.initWithResource("layout/transfernote/TransferNoteListView.html");
        return vc;
    }

    protected get sectionControllerID():string {
        return SectionViewControllerType.TransferNote;
    }

    protected noteStatusForSegmentedIndex(index){
        if (index == 1) return StockNoteStatus.Processed;        
        return StockNoteStatus.None;
    }
    
    cellAtIndexPath(tableview, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier('TransferNoteCell') as TransferNoteCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as TransferNote;
    
        cell.item = item;
        cell.selected = this.selectedNote == item ? true : false;

        return cell;
    }
        
    set fetchedResultsController(value){
        this.setFetchedResultsController(value);
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;
    
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("documentID", false)];
        if (this.selectedStatus == StockNoteStatus.Processed) {
            sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("creationDate", false)];
        }   
                
        let predicateFormat = "status == " + this.selectedStatus;
        if (ad.selectedIdentifierType == "place") predicateFormat += " AND placeID == '" + ad.selectedIdentifier + "'";
        if (this.searchString != null) {
            predicateFormat += " AND (documentID CONTAINS '" + this.searchString + "' OR internalOrder.documentID CONTAINS '" + this.searchString + "')";
        }
        if (this.filterPredicateFormat != null) {
            predicateFormat += " AND " + this.filterPredicateFormat;
        }

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("TransferNote", sortDescriptors, predicateFormat);
        fetchRequest.fetchLimit = 50;
        fetchRequest.relationshipKeyPathsForPrefetching = ['creatorNote'];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller){
        this.tableView.reloadData();
    }

    private _filters = null;
    get filters(){
        if (this._filters != null) return this._filters;

        this._filters = [FilterOption.filterWithTitle("FromDate", "From day", "validationDate", FilterFieldType.Date, null, FilterControllerComparatorType.MajorOrEqualComparator, null, "00:00:00"),
                FilterOption.filterWithTitle("ToDate", "To day", "validationDate", FilterFieldType.Date, null, FilterControllerComparatorType.MinorOrEqualComparator, null, "23:59:59"),                
                FilterOption.filterWithFetchRequest("Origin", "From warehouse", "originWarehouse.identifier", FilterFieldType.DropDown, "Warehouse", "name", "identifier", MIOLocalizeString("SELECT_ORIGIN_WAREHOUSE", "Select origin warehouse")),
                FilterOption.filterWithFetchRequest("Destination", "To warehouse", "destinationWarehouse.identifier", FilterFieldType.DropDown, "Warehouse", "name", "identifier", MIOLocalizeString("SELECT_DESTINATION_WAREHOUSE", "Select destination warehouse"))];

        return this._filters;
    }
        
    protected showSelectedItem(){        
        let vc = TransferNoteDetailViewController.newInstance();
        vc.note = this.selectedNote;
        this.splitViewController.showDetailViewController(vc);
    }

    protected showNoItemSelected(){
        let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("TransferNote", NoItemSelectedViewControllerType.TransferNote);
        this.splitViewController.showDetailViewController(vc);
    }

    protected showAddNoteViewController(){
        
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("ADD_TRANSFER_NOTE", "ADD TRANSFER NOTE"), MIOLocalizeString("CHOOSE_ORIGIN_AND_DESTINATION_PLACE", "CHOOSE ORIGIN AND DESTINATION PLACE"), MUIAlertViewStyle.Default);
        
        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
        
            let p = MIOPredicate.predicateWithFormat("parent.identifier == " + MUIWebApplication.sharedInstance().delegate.selectedIdentifier);
            DBHelper.sharedInstance().addObserverForEntity(comboBox, 'Place', p, null, null, function (objects:Place[]) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++)
                    comboBox.addItem(objects[i].name, i);
            });
        });
        
        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
            let p = MIOPredicate.predicateWithFormat("parent.identifier == " + MUIWebApplication.sharedInstance().delegate.selectedIdentifier);
            DBHelper.sharedInstance().addObserverForEntity(comboBox, 'Place', p, null, null, function (objects:Place[]) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++)
                    comboBox.addItem(objects[i].name, i);
            });
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('DONE','Done'), MUIAlertActionStyle.Default, this, function(){
            let origin_index = parseInt( avc.comboBoxes[0].getSelectedItem() );
            let destination_index = parseInt( avc.comboBoxes[1].getSelectedItem() );
            
            if ( origin_index == destination_index ) {
                AppHelper.showErrorMessage(this, "Error", "Origin and destination place can't be the same.");
                return;
            }

            let origin = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc.comboBoxes[0], origin_index, 'Place');
            let destination = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc.comboBoxes[1], destination_index, 'Place');
            this.addTransferNote(origin, destination);
            
        }));
        
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));
        
        avc.addCompletionHandler(this, function () {
            // Release the observers
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc.comboBoxes[0], 'Place');
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc.comboBoxes[1], 'Place');
        });
        
        this.presentViewController(avc, true);
    }

   private addTransferNote(originPlace:Place, destinationPlace:Place){

        DBHelper.createTransferNote(originPlace, destinationPlace, (note:SupplierNote) => {
            this.selectedNote = note;
            DBHelper.saveMainContext();
            this.showSelectedItem();
        });        
   }
}
